// src/App.js

import React, { useEffect } from 'react';
import './App.css';
import OurServices from './components/ourServices.js';
import Navbar from './components/nav-bar';
import Banner from './components/banner';
import BannerImg from './assets/banner.png';
import OurMissionBackground from './assets/OurMissionBackground.png';
import Footer from './components/footer.js';
import Form from './components/form';
import Cards from './components/cards';
import { FaLinkedin } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './i18n';
import { detectCountry } from './utils/detectCountry';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CybersecurityPosture from './components/cybersecurityPosture';
import DetectionOfDataLeaks from './components/detectionOfDataLeaks';
import PreventionOfDataLoss from './components/preventionOfDataLoss';
import HealingProcess from './components/healingProcess';
import ScrollToTop from './components/scrollToTop';

function App() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    function setLanguage() {
      const userLanguage = detectCountry();
      if (userLanguage.startsWith('es')) {
        i18n.changeLanguage('es');
      } else {
        i18n.changeLanguage('en');
      }
    }

    setLanguage();
  }, [i18n]);

  useEffect(() => {
    window.i18n = i18n;
  }, [i18n]);

  useEffect(() => {
    document.title = t('title').replace('\n', ' ');
  }, [t]);

  const HomeContent = () => (
    <>
      <div id="header" className="mb-5 mt-xl-0 pt-xl-0">
        <Banner
          title={t('title')}
          image={BannerImg}
          imagePosition="right"
          description={t('bannerDescription')}
        >
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '2px' }}>
            <a href="https://www.linkedin.com/company/safeusoftware/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin color="#DDFF0D" size={50} />
            </a>
          </div>
        </Banner>
      </div>
      <div className="our-service-background">
        <div className="mb-0 mb-md-5">
          <Cards />
        </div>
        <div id="infinitService" className="mb-5 pt-5">
          <OurServices />
        </div>
        <div id="about">
          <Banner
            title={t('missionTitle')}
            description={t('missionDescription')}
            image={OurMissionBackground}
            button={t('contactUs')}
            imagePosition="left"
          />
        </div>
      </div>
      <div id="form" className="pb-lg-0 mb-xl-0">
        <Form />
      </div>
      <div id="footer">
        <Footer />
      </div>
    </>
  );

  return (
    <Router>
      <ScrollToTop />
      <div className="App content">
        <div id="navBar" className="mt-3 pb-md-0 mb-md-0">
          <Navbar showAbout={true} />
        </div>
        <Routes>
          <Route
            path="/cybersecurity-posture"
            element={
              <div className="cybersecurity-posture-view">
                <CybersecurityPosture />
              </div>
            }
          />
          <Route
            path="/detection-of-data-leaks"
            element={
              <div className="cybersecurity-posture-view">
                <DetectionOfDataLeaks />
              </div>
            }
          />
          <Route
            path="/prevention-of-data-loss"
            element={
              <div className="cybersecurity-posture-view">
                <PreventionOfDataLoss />
              </div>
            }
          />
          <Route
            path="/healing-process"
            element={
              <div className="cybersecurity-posture-view">
                <HealingProcess />
              </div>
            }
          />
          <Route path="/" element={<HomeContent />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
